module.exports = __webpack_public_path__ + "static/media/gris-g.8a67a6a9.mp3";